import { AfterViewInit, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-sales-report-statistics',
    templateUrl: './sales-report-statistics.component.html',
    styleUrls: ['./sales-report-statistics.component.css'],
    standalone: false
})
export class SalesReportStatisticsComponent implements OnInit {

  @Input() resRevTotal: any = [];
  @Input() resRevMaster: any = [];
  @Input() revenueTtl: any = [];
  @Input() revenuePNTAvg: any = [];

  revRoomRateNetTTL: any;
  revRoomRateNetAVG: any;
  numResTTL: any;
  numNtsGuestTTL: any;
  numNtsGuestAVG: any;

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    
    if(this.resRevTotal && this.resRevTotal.length > 0) {
      this.revRoomRateNetTTL = this.currencyCellRendererUSD(this.resRevTotal[0].revRoomRateNetTTL);
      this.revRoomRateNetAVG = this.currencyCellRendererUSD(this.resRevTotal[0].revRoomRateNetAVG);
      this.numResTTL = this.resRevTotal[0].numGuestRes;
      this.numNtsGuestTTL = this.resRevTotal[0].numNtsGuestTTL;
      // this.numNtsGuestAVG = this.resRevTotal[0].numNtsGuestAVG;
      //Changed as per request on 11Jul2024
      this.numNtsGuestAVG = this.numNtsGuestTTL / this.numResTTL;
      }
  }

  currencyCellRendererUSD(params: any) {
		let inrFormat = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
		return inrFormat.format(params);
	}

}
